import { useState } from 'react'
import styles from './LoginPage.module.scss'
import { Signup } from './Signup/Signup'
import { WebsiteDescription } from './WebsiteDescription/WebsiteDescription'
import { RestorePassword } from './RestorePassword/RestorePassword'
import { IntroductionVideo } from './IntroductionVideo/IntroductionVideo'
import { FeaturesList } from './FeaturesList/FeaturesList'
import { LogoSection } from './LogoSection/LogoSection'
import { LoginPageType, LoginPageTypes } from './LoginPageTypes'
import { AuthForm } from './AuthForm/AuthForm'
import { Footer } from './Footer/Footer'
import { ModalFancy } from '../../components/UI/Modals/ModalFancy/ModalFancy'
import { LOGIN_PAGE_PRODUCT_DESCRIPTION } from '../../const/consts'
import { MigrationNotice } from './MigrationNotice/MigrationNotice'

export const LoginPage = (): JSX.Element => {
  const [formType, setFormType] = useState<LoginPageTypes>(LoginPageType.LOGIN)

  return (
    <div className={styles.LoginPageContainer}>
      <MigrationNotice />
      <LogoSection />
      <div className={styles.InfoSectionsContainer}>
        <IntroductionVideo />
        <ModalFancy>
          <>
            <WebsiteDescription
              productDescription={LOGIN_PAGE_PRODUCT_DESCRIPTION}
            />
            {formType === 'LOGIN' && (
              <AuthForm changeFormHandler={setFormType} />
            )}
            {formType === 'SIGNUP' && (
              <Signup changeFormHandler={setFormType} />
            )}
            {formType === 'RESTORE' && (
              <RestorePassword changeFormHandler={setFormType} />
            )}
          </>
        </ModalFancy>
        <FeaturesList />
      </div>
      <Footer />
    </div>
  )
}
